import Vue from 'vue';
import CookieBlocker from './cookie-blocker';

// Main component
Vue.component('cookie-blocker', CookieBlocker);

export default CookieBlocker;


// WEBPACK FOOTER //
// ./scripts/cookie-blocker/index.js